import React from 'react';
import { Button, IconButton, Tooltip } from '@mui/material';
import { SmartToy } from '@mui/icons-material';

interface AIHelpButtonProps {
  onClick: () => void;
  variant?: 'button' | 'icon';
  label?: string;
  size?: 'small' | 'medium' | 'large';
  /** Tooltip for the icon variant. Defaults to "Ask Mozi". */
  tooltip?: string;
  /** Accessible name for the icon variant. Defaults to `label`. */
  ariaLabel?: string;
}

export const AIHelpButton: React.FC<AIHelpButtonProps> = ({
  onClick,
  variant = 'button',
  label = 'Ask Mozi',
  size = 'medium',
  tooltip = 'Ask Mozi',
  ariaLabel,
}) => {
  if (variant === 'icon') {
    return (
      <Tooltip title={tooltip}>
        <IconButton
          size={size}
          onClick={onClick}
          aria-label={ariaLabel ?? label}
          sx={{
            color: 'primary.main',
            '&:hover': {
              bgcolor: 'primary.light',
            },
          }}
        >
          <SmartToy />
        </IconButton>
      </Tooltip>
    );
  }

  return (
    <Button
      variant="outlined"
      startIcon={<SmartToy />}
      onClick={onClick}
      size={size}
      sx={{
        textTransform: 'none',
      }}
    >
      {label}
    </Button>
  );
};
